import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaAbove';
const args = {};

export class OligonKentimaAbove extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
